// import widgetConfigApi from '../components/api/widgetConfigApi'
// import formUtils from './formUtils'
// import alertUtils from './alertUtils'

/**
 * 配置表单  工具
 */
export default class widgetFormUtils {
  // 组件拖拽 新增时做的操作
  static handleWidgetAdd(newIndex, to, data, obj, isSon) {
    // 为拖拽到容器的元素添加唯一 key
    const key = data.list[newIndex].key
      ? data.list[newIndex].key
      : new Date().getTime() + ''

    const model =
      data.list[newIndex].type +
      (data.list[newIndex].type === 'sonform' ? '_colorful_egg' : '') +
      '_' +
      key

    obj.$set(data.list, newIndex, {
      ...data.list[newIndex],
      options: {
        ...data.list[newIndex].options,
        // remoteFunc: 'func_' + key
      },
      eventOptions: {
        ...data.list[newIndex].eventOptions,
      },
      key,
      // 绑定键值
      model: data.list[newIndex].model ? data.list[newIndex].model : model,
      rules: [],
    })
    if (isSon) {
      data.list[newIndex].options.isSon = true
    } else {
      data.list[newIndex].options.isSon = false
    }
    if (
      Object.prototype.hasOwnProperty.call(
        data.list[newIndex].options,
        'options'
      )
    ) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        options: {
          ...data.list[newIndex].options,
          options: [
            ...data.list[newIndex].options.options.map(item => ({
              ...item,
            })),
          ],
        },
      })
    }
    if (
      Object.prototype.hasOwnProperty.call(
        data.list[newIndex].options,
        'dicTypeCode'
      )
    ) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        options: {
          ...data.list[newIndex].options,
          dicTypeCode: JSON.parse(
            JSON.stringify(data.list[newIndex].options.dicTypeCode)
          ),
        },
      })
    }
    if (
      Object.prototype.hasOwnProperty.call(data.list[newIndex].options, 'props')
    ) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        options: {
          ...data.list[newIndex].options,
          props: JSON.parse(JSON.stringify(data.list[newIndex].options.props)),
        },
      })
    }
    if (
      Object.prototype.hasOwnProperty.call(
        data.list[newIndex].options,
        'carNumberOptions'
      )
    ) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        options: {
          ...data.list[newIndex].options,
          carNumberOptions: JSON.parse(
            JSON.stringify(data.list[newIndex].options.carNumberOptions)
          ),
        },
      })
    }

    if (
      Object.prototype.hasOwnProperty.call(
        data.list[newIndex].options,
        'variables'
      )
    ) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        options: {
          ...data.list[newIndex].options,
          variables: JSON.parse(
            JSON.stringify(data.list[newIndex].options.variables)
          ),
        },
      })
    }
    if (
      Object.prototype.hasOwnProperty.call(
        data.list[newIndex].options,
        'remoteOptions'
      )
    ) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        options: {
          ...data.list[newIndex].options,
          remoteOptions: JSON.parse(
            JSON.stringify(data.list[newIndex].options.remoteOptions)
          ),
        },
      })
    }
    // if (
    //   Object.prototype.hasOwnProperty.call(
    //     data.list[newIndex].options,
    //     'defaultValue'
    //   ) &&
    //   Object.prototype.hasOwnProperty.call(
    //     data.list[newIndex].options.defaultValue,
    //     'selectValue'
    //   )
    // )
    if (
      Object.prototype.hasOwnProperty.call(
        data.list[newIndex].options,
        'defaultValue'
      )
    ) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        options: {
          ...data.list[newIndex].options,
          defaultValue: JSON.parse(
            JSON.stringify(data.list[newIndex].options.defaultValue)
          ),
        },
      })
    }
    if (
      Object.prototype.hasOwnProperty.call(
        data.list[newIndex].eventOptions,
        'eventObj'
      )
    ) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        eventOptions: {
          ...data.list[newIndex].eventOptions,
          eventObj: [
            ...data.list[newIndex].eventOptions.eventObj.map(item => ({
              ...item,
            })),
          ],
        },
      })
    }
    if (Object.prototype.hasOwnProperty.call(data.list[newIndex], 'columns')) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        columns: [
          ...data.list[newIndex].columns.map(item => ({
            ...item,
            list: [...item.list],
          })),
        ],
      })
    }
    if (Object.prototype.hasOwnProperty.call(data.list[newIndex], 'rows')) {
      obj.$set(data.list, newIndex, {
        ...data.list[newIndex],
        rows: [
          ...data.list[newIndex].rows.map(rowItem => ({
            columns: [
              ...rowItem.columns.map(columnItem => ({
                ...columnItem,
                list: [...columnItem.list],
              })),
            ],
          })),
        ],
      })
    }
  }
}
